// Estilo do modal de Limite de Reposição.
//
// Só o que a casca (`_casca.ts`) NÃO tem. `NotaDeCampo`, `ExplicacaoCurta` e
// `LinhaDeDias` repetem os de SupplierModal.ts de propósito: são duas folhas de
// componente, no padrão "um arquivo de estilo por componente" do repo, e uma
// terceira folha só para três regras seria uma casca paralela à `_casca`.
//
// Tokens: só `var(--u)`, `var(--fs-*)` e `var(--sp-*)`.
import styled from "styled-components";

/** Texto que conta uma dívida na tela: campo sem onde gravar, rota que falta. */
export const NotaDeCampo = styled.p`
  grid-column: 1 / -1;
  margin: var(--sp-8) 0 0 0;
  font-size: var(--fs-xs);
  line-height: 1.5;
  color: #5b6b7b;

  code {
    font-family: ui-monospace, "SF Mono", Menlo, monospace;
    font-size: var(--fs-2xs);
    background: #eef2f6;
    padding: 0 var(--sp-4);
    border-radius: 4px;
  }
`;

export const ExplicacaoCurta = styled.div`
  font-size: var(--fs-2xs);
  line-height: 1.5;
  color: #6b7885;
`;

export const LinhaDeDias = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-8);
`;

export const BotaoDeDia = styled.button<{ ativo?: boolean }>`
  padding: var(--sp-6) var(--sp-12);
  border-radius: 999px;
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: ${(props) => (props.ativo ? 600 : 400)};
  border: 1px solid
    ${(props) =>
      props.ativo
        ? props.theme.colors.selection
        : props.theme.colors.borderColor || "#e0e0e0"};
  background: ${(props) =>
    props.ativo ? props.theme.colors.selection + "22" : "transparent"};
  color: ${(props) => props.theme.colors.text};
`;

/** Grupo de escolha exclusiva (modo de quantidade, de preço, de ação). */
export const GrupoDeRadio = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-16);
  margin-bottom: var(--sp-12);
`;

export const OpcaoDeRadio = styled.label`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  cursor: pointer;
  font-size: var(--fs-md);
  color: ${(props) => props.theme.colors.text};
`;

/**
 * A linha viva: a conta refeita a cada digitação, com a suposição escrita ao
 * lado. Fundo diferente do resto justamente para não passar por campo — não é
 * dado gravado, é resultado.
 */
export const LinhaViva = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
  padding: var(--sp-12);
  border-radius: 8px;
  background: #f4f7f9;
  border: 1px dashed #cbd6e0;
  font-size: var(--fs-sm);
  color: #3d4d5c;
`;

export const ValorDaLinhaViva = styled.div`
  display: flex;
  align-items: baseline;
  gap: var(--sp-8);
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
`;

/**
 * A etiqueta que não pode sumir: "sem módulo de estoque, considera saldo 0".
 * O número acima dela é o pedido MAIOR possível; sem a etiqueta, ele parece
 * uma medição do estoque real.
 */
export const EtiquetaDeSuposicao = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--sp-6);
  align-self: flex-start;
  padding: var(--sp-4) var(--sp-10);
  border-radius: 999px;
  font-size: var(--fs-2xs);
  font-weight: 600;
  background: #fdf7e7;
  color: #7a5a12;
  border: 1px solid #f0dcae;
`;

/** O texto que explica quem manda quando duas fontes discordam. */
export const RegraDeAutoridade = styled.div`
  grid-column: 1 / -1;
  padding: var(--sp-10) var(--sp-12);
  border-left: 3px solid ${(props) => props.theme.colors.selection};
  background: ${(props) => props.theme.colors.selection + "10"};
  border-radius: 0 8px 8px 0;
  font-size: var(--fs-sm);
  line-height: 1.5;
  color: ${(props) => props.theme.colors.text};
`;
